import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../../ChartCalls';
import { config } from '../../../constant';
import { geoLocations } from '../../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../../Utils';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
//import { property } from 'lodash';

const customIcon = new L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const GeoMapComponent = (props) => {

  //const [columns,setColumns] = useState([]);
  //const [tableData,setTableData] = useState([]);
  const [, setLoading] = useState(false);
  // const [translationCache,setTranslationCache] = useState(props.translationCache || []);
  // const [language,setLanguage] = useState(props.language || 'English');
  const [, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  // const [trainList,setTrainLIst] = useState([]);
  const extraKeys = useState({ Type: 'Running' });
  const [json, setJson] = useState();

  // columns = [];
  // tabledata = [];

  // let config = {
  //   redirectTo: 'counter'
  // };

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  let abortController = useRef(new window.AbortController());
  //let rowUpdateInterval = null;

  useEffect(() => {
    if (timeTicket) {
      clearInterval(timeTicket);
    }
    getData(extraKeys, props.deviceId);
    let refreshTime = '';
    if (props.graphprops.refreshTime) {
      refreshTime = props.graphprops.refreshTime * 60000;
    } else {
      refreshTime = config;
    }

    timeTicket.current = setInterval(() => {
      if (requestCheck) {
        getData(extraKeys, props.deviceId);
      }
    }, refreshTime);

    return () => {
        abortController.current.abort();
      clearInterval(timeTicket);
    };
  }, []);

  // useEffect(() => {
  // getData(extraKeys,deviceId)
  // },[props.graphprops,props.selectionDate,props.selectionDateLive,props.selectionMonth,props.selectionWeek,props.deviceId,props.DeviceCode,props.shift,props.selectionDateRange,props.dayMonthYear,props.dropdownSelection,props.dashboardPayload,props.AssetCode,props.translationCache])

  async function getData() {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = geoLocations;
      requestCheck.current = true;
    } else {
      if (
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
          props.selectionDate) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'monthPicker' ||
            graphprops.GraphLevelSelection === 'monthPicker') &&
          props.selectionMonth) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'weakPicker' ||
            graphprops.GraphLevelSelection === 'weakPicker') &&
          props.selectionWeek) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'shiftPicker' ||
            graphprops.GraphLevelSelection === 'shiftPicker') &&
          props.shift) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
            graphprops.GraphLevelSelection === 'dateRangePicker') &&
          props.selectionDateRange) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
          props.dayMonthYear) ||
        (graphprops && graphprops.dashboardType === 'dynamic') ||
        (graphprops.dashboardType === 'dropdownHide' && props.DeviceCode) ||
        (graphprops && graphprops.dashboardType === 'hierarchy' && props.dropdownSelection) ||
        (graphprops && props.dashboardPayload) ||
        (graphprops && graphprops.treeExists === 'true' && props.AssetCode)
      ) {
        json = await getChartDataWithSelection({
          graphprops,
          DeviceCode: props.DeviceCode,
          selectionDate: props.selectionDate,
          selectionMonth: props.selectionMonth,
          selectionWeek: props.selectionWeek,
          shift: props.shift,
          selectionDateRange: props.selectionDateRange,
          dayMonthYear: props.dayMonthYear,
          abortController: abortController,
          dropdownSelection: props.dropdownSelection,
          dashboardPayload: props.dashboardPayload,
          AssetCode: props.AssetCode,
          selectionDateLive: props.selectionDateLive,
          currentTimeZone: props.currentTimeZone,
          extraKeys: extraKeys
        });
        requestCheck.current = true;
      } else {
        json = await getChartDataWithoutSelection({
          graphprops,
          abortController: abortController,
          dropdownSelection: props.dropdownSelection,
          DeviceCode: props.DeviceCode,
          TimeZone: props.currentTimeZone
        });
        requestCheck.current = true;
        setLoading(false);
        setRefreshDateTime(moment());
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      setJson(json);
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);


  }
  const defaultlatidtude = 20.5937;
  const defaultlongitude = 78.9629;

  return (
    <Fragment>
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <>
          <MapContainer center={[20.5937, 78.9629]} zoom={5} style={{ height: '600px', width: '100%' }}>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            {json &&
              Array.isArray(json) &&
              json.map((location, index) => (
                <Marker
                  key={index}
                  position={[
                    location.latitude || defaultlatidtude,
                    location.longitude || defaultlongitude
                  ]}
                  icon={customIcon}
                >
                  <Popup>
                    {location.name} <br />
                    {/* lat: {location.latitude}, lng: {location.longitude} <br/>
                    parent Lat: {location.parentlatitude}, parent Lng: {location.parentLongitude} <br/> */}
                  </Popup>
                </Marker>
              ))}
          </MapContainer>
        </>
      )}
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
  };
};

export default connect(mapStateToProps)(GeoMapComponent);
